module.exports = __webpack_public_path__ + "media/images/front/icon_target-706608591b798026cdb6e29f50198265.png";